import { UploadDocumentType } from '@/constants/businessConstants'
import { UserDocument } from '../lib/userDocuments.slice'
import { StatementActionButton } from '../shared/StatementActionButton'
import { UploadRequiredDocumentButton } from '../shared/UploadRequiredDocumentButton'
import { UserDocumentActionButton } from '../shared/UserDocumentActionButton'

import { Table } from '@/ui'

interface ActionCellProps {
  document: UserDocument
}

// TODO: Migrate to V2 for delete dialog
// Keep with V1 Delete Modal until we migrate to V2. New version will use DialogTrigger.
export const ActionCell = ({ document }: ActionCellProps) => {
  if (document.id === -1) {
    return (
      <Table.Cell className="flex items-center justify-center overflow-visible">
        <UploadRequiredDocumentButton document={document} />
      </Table.Cell>
    )
  }

  return (
    <Table.Cell className="flex items-center justify-center overflow-visible">
      {document.documentType === UploadDocumentType.STATEMENT ? (
        <StatementActionButton document={document} />
      ) : (
        <UserDocumentActionButton document={document} />
      )}
    </Table.Cell>
  )
}
